"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.DropdownItem = react_1.forwardRef((props, ref) => {
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: ref, _hover: { backgroundColor: 'rgba(125,125,125,0.2)' }, paddingY: 2, paddingX: 3 }, props), void 0));
});
//# sourceMappingURL=index.js.map